import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6f9087ce&scoped=true&"
import script from "../../../services/layout/applicant-header.js?vue&type=script&lang=js&"
export * from "../../../services/layout/applicant-header.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9087ce",
  null
  
)

export default component.exports